import { render, staticRenderFns } from "./ShutdownNotices.vue?vue&type=template&id=77ed8d39&scoped=true&"
import script from "./ShutdownNotices.vue?vue&type=script&lang=js&"
export * from "./ShutdownNotices.vue?vue&type=script&lang=js&"
import style0 from "./ShutdownNotices.vue?vue&type=style&index=0&id=77ed8d39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ed8d39",
  null
  
)

export default component.exports